module.exports = __webpack_public_path__ + "static/media/instruction_kk.5f671597.pdf";